import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      alert(data.message);
    } catch (error) {
      console.error("Error:", error);
      alert("Server not running");
    }
  };

  return (
    <>
      <section id="contact" className="bg-dark-1">
        <div className="row no-gutters">
          <div className="col-md-5 col-lg-5 col-xl-6">
            <div className="section hero-wrap h-100 px-5 text-light">
              <div
                className="hero-bg hero-bg-scroll"
                style={{ backgroundImage: "url('/images/bg/image-2.jpg')" }}
              ></div>
            </div>
          </div>

          <div className="col-md-7 col-lg-7 col-xl-6">
            <div className="section h-100 px-5 mx-4">
              <h2 className="font-weight-600 text-white text-center mb-3">
                What's your Idea?
              </h2>
              <p className="lead text-muted text-center mb-5">
                We will get back to you in less than 24 hours.
              </p>

              <form
                className="form-border form-border-light"
                onSubmit={handleSubmit}
              >
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control border-1 font-weight-300"
                    placeholder="Name"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    className="form-control border-1 font-weight-300"
                    placeholder="Email"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    className="form-control border-1 font-weight-300"
                    rows="3"
                    placeholder="Tell us more about your needs........"
                    required
                    onChange={handleChange}
                  ></textarea>
                </div>

                <p className="text-center mt-5 mb-0">
                  <button
                    className="btn btn-primary rounded-pill d-inline-flex"
                    type="submit"
                  >
                    Send Message
                  </button>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
